var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"export-button",class:{
    'border-gray group hover:border-dark-silver p-3': !_vm.blue,
    'button-blue': _vm.blue
  },attrs:{"disabled":_vm.isExporting},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"flex"},[(_vm.content || _vm.$slots.default)?_c('div',{staticClass:"mr-2"},[_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2):_vm._e(),_c('div',[_c('icon',{class:{
          'animated loop tada': _vm.isExporting,
          'icon-lg text-dark-silver group-hover:text-gunmetal': !_vm.blue
        },attrs:{"icon":_vm.icon,"spin":_vm.isExporting}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }